<template>
    <div>
        <div class="topnav" id="myTopnav">
            <a class="img">
                <img src="https://space.monresto.menu/new_images/logo_picto_dark.png" alt="" class="logo_prog">
            </a>
            <div class="nav-right">
                <a href="javascript:void(0);" class="icon" id="icon" @click="responav()">&#9776;</a>
                <router-link :to="{ path: '/client' }">
                    Votre profil
                </router-link>
                <router-link :to="{ path: '/historique' }">
                    Vos commandes
                </router-link>
                <a href="" @click="logout">Deconnexion</a>
            </div>
        </div>

        <div id="menu">
            <div id="menu-bar" @click="menuOnClick()">
                <div id="bar1" class="bar"></div>
                <div id="bar2" class="bar"></div>
                <div id="bar3" class="bar"></div>
            </div>
            <nav class="nav" id="nav">
                <ul>
                    <li>
                        <router-link :to="{ path: '/client' }">
                            Votre profil
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ path: '/historique' }">
                            Vos commandes
                        </router-link>
                    </li>
                    <li><a href="" @click="logout">Deconnexion</a></li>
                </ul>
            </nav>
        </div>
        <div class="menu-bg" id="menu-bg"></div>

    </div>
</template>

<script>
export default {
    name: 'Nav',
    methods: {
        logout() {
            localStorage.setItem("accessToken", "")
            setTimeout(() => {
                this.$router.push({ name: 'Login' })
            }, 200)
        },
        responav() {
            var x = document.getElementById("myTopnav");
            if (x.className === "topnav") {
                // document.getElementById("icon").innerHTML="&#x58;"
                x.className += " responsive";

            } else {
                x.className = "topnav";
            }
        },
        menuOnClick() {
            document.getElementById("menu-bar").classList.toggle("change");
            document.getElementById("nav").classList.toggle("change");
            document.getElementById("menu-bg").classList.toggle("change-bg");
        }
    }
}
</script>

<style scoped>
/* #menu {
    z-index: 2;

}

#menu-bar {
    width: 45px;
    height: 40px;
    margin: 30px 0 20px 20px;
    cursor: pointer;
    background-color: #f05d2e;
    border-radius: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: fixed;
    padding: 10px;
    border: 1px solid #fff;
    
}

.bar {
    height: 5px;
    width: 100%;
    background: linear-gradient(160deg, #1e3a34, #264740);
    display: block;
    border-radius: 5px;
    transition: 0.3s ease;
}

#bar1 {
    transform: translateY(-4px);
}

#bar3 {
    transform: translateY(4px);
}

.nav {
    transition: 0.3s ease;
    display: none;
    
}

.nav ul {
    padding: 0 22px;
}

.nav li {
    list-style: none;
    padding: 12px 0;
}

.nav li a {
    color: white;
    font-size: 20px;
    text-decoration: none;
}

.nav li a:hover {
    font-weight: bold;
}

.menu-bg,
#menu {
    top: 0;
    left: 0;
    position: absolute;
}

.menu-bg {
    z-index: 1;
    width: 0;
    height: 0;
    margin: 30px 0 20px 20px;
    background: linear-gradient(135deg, #D4714E, #C0603F);
    border-radius: 50%;
    transition: 0.3s ease;
    position: fixed;
}

.change {
    display: block;
    position: fixed;
}

.change .bar {
    background-color: white;
}

.change #bar1 {
    transform: translateY(4px) rotateZ(-45deg);
}

.change #bar2 {
    opacity: 0;
}

.change #bar3 {
    transform: translateY(-6px) rotateZ(45deg);
}

.change-bg {
    width: 520px;
    height: 460px;
    transform: translate(-60%, -30%);
} */




/* /////////////////////////////////////////////////////////////////////////// */
/* Add a black background color to the top navigation */

#menu{
    display: none;
}
.topnav {
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    background-color: #fff;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    position: fixed;
    top: 0;
    width: 100%;
    box-sizing: border-box;
    z-index: 1;
    
}

/* Style the links inside the navigation bar */
.topnav a {
    /* float: left; */
    display: block;
    color: #1e3a34;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
    font-size: 17px;
    transition: .5s;
    /* z-index: 10; */
    height: auto;
    /* position: relative; */

}

.topnav a:before {
    transform: scaleY(2);
    opacity: 0;
    transition: .3s;
}

.topnav a:after {
    transform: scale(0);
    opacity: 0;
    transition: .3s;
    z-index: -1;
}

.topnav a:hover:before {
    color: #fff;
    transform: scaleY(1);
    opacity: 1;
}

.topnav a:hover:after {
    color: #fff;
    transform: scaleY(1);
    opacity: 1;
}


/* Hide the link that should open and close the topnav on small screens */
.topnav .icon {
    display: none;
}


/* Add a dark background on topnav links and the dropdown button on hover */
.topnav a:hover {
    background-color: #f05d2e;
    color: white;
    border-radius: 3%;
}

.topnav .img:hover {
    background-color: #fff;
}


.topnav img {
    height: 40px;
}

.nav-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    /* align-self: ; */
    /* position: relative; */

}

/* When the screen is less than 600 pixels wide, hide all links, except for the first one ("Home"). Show the link that contains should open and close the topnav (.icon) */
@media screen and (max-width: 600px) {

    .topnav {
        display: none;
    }

    .topnav a:not(:first-child) {
        display: none;
    }

    #menu {
        display: block;
        z-index: 2;
        position: fixed;
    }

    #menu-bar {
        width: 45px;
        height: 40px;
        margin: 30px 0 20px 20px;
        cursor: pointer;
        background-color: #f05d2e;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 10px;
        border-radius: 30%;
        border: 1px solid #fff;
        /* position: fixed; */
    }

    .bar {
        height: 5px;
        width: 100%;
        background-color: #fff;
        display: block;
        border-radius: 5px;
        transition: 0.3s ease;

    }

    #bar1 {
        transform: translateY(-4px);
    }

    #bar3 {
        transform: translateY(4px);
    }

    .nav {
        transition: 0.3s ease;
        display: none;
    }

    .nav ul {
        padding: 0 22px;
    }

    .nav li {
        list-style: none;
        padding: 12px 0;
    }

    .nav li a {
        color: white;
        font-size: 20px;
        text-decoration: none;
    }

    .nav li a:hover {
        font-weight: bold;
    }

    .menu-bg,
    #menu {
        top: 0;
        left: 0;
        position: absolute;
    }

    .menu-bg {
        z-index: 1;
        width: 0;
        height: 0;
        margin: 30px 0 20px 20px;
        background: linear-gradient(135deg, #D4714E, #C0603F);
        border-radius: 50%;
        transition: 0.3s ease;
    }

    .change {
        display: block;
    }

    .change .bar {
        background-color: white;
    }

    .change #bar1 {
        transform: translateY(4px) rotateZ(-45deg);
    }

    .change #bar2 {
        opacity: 0;
    }

    .change #bar3 {
        transform: translateY(-6px) rotateZ(45deg);
    }

    .change-bg {
        width: 520px;
        height: 460px;
        transform: translate(-60%, -30%);
    }

    /* .topnav a:not(:first-child),
    .nav-right a,
    .dropdown .dropbtn {
        display: none;
    }

    .topnav a.icon {
        float: right;
        display: block;
    }

    .topnav.responsive {
        position: relative;
    }


    .topnav.responsive a.icon {
        position: absolute;
        right: 0;
        top: 0;
    }

    .nav-right {
        
        display: block;
        text-align: left;
    }


    .topnav.responsive a {
        
        display: block;
        text-align: left;
    } */
}
</style>